import { render, staticRenderFns } from "./TariffCalculatorContractConclusion.vue?vue&type=template&id=2c5447bb&scoped=true&"
import script from "./TariffCalculatorContractConclusion.vue?vue&type=script&lang=ts&"
export * from "./TariffCalculatorContractConclusion.vue?vue&type=script&lang=ts&"
import style0 from "./TariffCalculatorContractConclusion.vue?vue&type=style&index=0&id=2c5447bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5447bb",
  null
  
)

export default component.exports